export const zIndexDialogs = 900;
export const zIndexPopovers = 800;
export const zIndexStickyTopPanel = 11;
export const zIndexStickies = 10;
export type ThemePaletteType = "light" | "dark";
